"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("@atlaskit/theme/colors");
const react_simple_code_editor_1 = __importDefault(require("react-simple-code-editor"));
const theme_1 = require("@atlaskit/theme");
const theme_2 = require("../theme");
const prism_react_renderer_1 = __importStar(require("prism-react-renderer"));
const nightOwl_1 = __importDefault(require("prism-react-renderer/themes/nightOwl"));
const nightOwlLight_1 = __importDefault(require("prism-react-renderer/themes/nightOwlLight"));
const CodeBG = styled_components_1.default.div `
  background: ${theme_1.themed({ light: colors_1.N30, dark: colors_1.DN10 })};
  margin-top: 10px;
  height: 100%;
  width: 100%;
  caret-color: ${({ uneditable }) => uneditable
    ? "transparent"
    : `${theme_1.themed({ light: "black", dark: "white" })};`};
`;
exports.CodeEditor = ({ defaultCode = "", fontSize = 12, fontFamily = `"Fira code", "Fira Mono", monospace`, onChange = code => { }, language = "javascript", uneditable = false }) => {
    const [code, setCode] = React.useState(defaultCode || "");
    const theme = theme_2.useTheme();
    React.useEffect(() => {
        setCode(defaultCode);
    }, [defaultCode]);
    const highlight = (language) => (code) => (React.createElement(prism_react_renderer_1.default, Object.assign({}, prism_react_renderer_1.defaultProps, { code: code, language: language, theme: theme.mode === "light" ? nightOwlLight_1.default : nightOwl_1.default }), ({ className, style, tokens, getLineProps, getTokenProps }) => (React.createElement(React.Fragment, null, tokens.map((line, i) => (React.createElement("div", Object.assign({}, getLineProps({ line, key: i })), line.map((token, key) => (React.createElement("span", Object.assign({}, getTokenProps({ token, key }))))))))))));
    return (React.createElement(CodeBG, { uneditable: uneditable },
        React.createElement(react_simple_code_editor_1.default, { value: code, onValueChange: code => {
                if (uneditable) {
                    return;
                }
                onChange(code);
                setCode(code);
            }, highlight: highlight(language), padding: 10, style: {
                fontFamily,
                fontSize
            } })));
};
